
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

import { SettingsFilesV1Field } from "../settings-files-v1.class";
import { FieldsStandardRemoveMenuItem, FieldsMenuMoveDown, FieldsMenuMoveUp, FieldsMenuReallyRemove } from '../../../settings-field-menu/fields.menu';
import { FormsFieldItemMenuClick } from '../../../settings-field-menu/field-menu-item.model';

@Component({
    selector: 'form-field-settings-files-v1',
    templateUrl: './settings-files-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsFilesV1FieldComponent implements OnInit, OnChanges{
    @Input() field: SettingsFilesV1Field;
    @Output() fieldChange = new EventEmitter<SettingsFilesV1Field>();
    @Output() menuClick = new EventEmitter<FormsFieldItemMenuClick>();

    public placeholder: string = "Name of the File(s) field";
    public form: FormGroup = new FormGroup({});
    public fieldMenu: Array<ThreeDotsMenuItem> = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp];

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
    }
    
    ngOnChanges(changes: SimpleChanges): void {
        if(changes.field){
            this.cdr.markForCheck();
        }
    }

    onMandatoryChange(mandatory: boolean) {
        this.field = this.field.update({ mandatory: mandatory});
        this.emit(this.field);
    }

    onFieldChange(labelText: string) {
        this.emit(this.field.update({ label: labelText}));
    }

    onMenuClick(key: string) {
        // see ThreeDotsMenuItem interface definition to see how works this confirmation remove
        switch(key) {
            case "confirmation-remove":
                this.fieldMenu = [FieldsMenuMoveDown,  FieldsMenuMoveUp, FieldsMenuReallyRemove];
                break;
            case "dismiss-really-remove": // pseudo key to return to basic menu
                this.fieldMenu = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp];
                break;
            default:
                const itemClicked: FormsFieldItemMenuClick = {key: key, field: this.field}
                this.menuClick.emit(itemClicked);
        }
    }

    private emit(updatedField: SettingsFilesV1Field): void {
        this.fieldChange.emit(updatedField);
    }
}   